import Button from "@mui/material/Button";
import {
  Stack,
  Divider,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Chip,
  Grid,
} from "@mui/material";

import {
  FieldSelect,
  FieldAutocomplete,
  FieldTextarea,
} from "../../../../../components/Fields";

import "../../styles.css";

export default function Laboratorio({
  onSubmit,
  data,
  setData,
  handleExamesPredefinidosOptions,
  examesPredefinidosOptions,
  handleCheckedField,
  examesPredefinidosList,
  readOnly,
}) {
  return (
    <form autoComplete="off" onSubmit={onSubmit}>
      <Stack className="templateGridForm">
        <FieldSelect
          label="Exames predefinidos"
          value={data.examesPredefinidosSelect}
          setValue={(value) => handleExamesPredefinidosOptions(value)}
          items={examesPredefinidosOptions.map((c) => {
            return { id: c.value, label: c.key };
          })}
          isEditField={!readOnly}
        />
        {[1, 2, 3].map((index) => (
          <Stack key={index}></Stack>
        ))}
      </Stack>

      <Grid
        container
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(250px, 1fr))`,
          gap: "0px",
        }}
      >
        <FormGroup
          onChange={(e) =>
            handleCheckedField(e, "examesPredefinidosExamesEProcedimentos")
          }
          sx={{
            display: "grid",
            gridAutoFlow: "column", // Preenche 12 linhas antes de criar uma nova coluna
            gridTemplateRows: "repeat(12, auto)", // Cada coluna tem até 12 itens
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            "@media only screen and  (max-width: 1175px)": {
              gridTemplateRows: "repeat(23, auto)",
            },
            "@media only screen and  (max-width: 650px)": {
              gridAutoFlow: "row", // P
            },
          }}
        >
          {examesPredefinidosList.map(({ key, value }) => {
            return (
              <FormControlLabel
                disabled={readOnly}
                control={<Checkbox />}
                label={key}
                key={key}
                value={value}
                checked={data.examesPredefinidosExamesEProcedimentos.includes(
                  value
                )}
              />
            );
          })}
        </FormGroup>
      </Grid>

      {/* <FormGroup
        className="templateGridFormCheckbox CheckboxColor"
        onChange={(e) =>
          handleCheckedField(e, "examesPredefinidosExamesEProcedimentos")
        }
        sx={{
          gridTemplateColumns: `repeat(auto-fit, minmax(250px, 1fr))`,
        }}
      >
        {examesPredefinidosList.map(({ key, value }) => {
          return (
            <FormControlLabel
              disabled={readOnly}
              control={<Checkbox />}
              label={key}
              key={key}
              value={value}
              checked={data.examesPredefinidosExamesEProcedimentos.includes(
                value
              )}
            />
          );
        })}
      </FormGroup> */}
      <Divider sx={{ mb: 2, mt: 2 }} />

      <FieldAutocomplete
        label="Outros exames laboratoriais"
        multiple
        options={[]}
        getOptionLabel={(option) => ""}
        freeSolo
        value={data.outrosExamesLaboratoriais}
        setValue={(e, newValue) => {
          setData((prevState) => ({
            ...prevState,
            outrosExamesLaboratoriais: [
              ...prevState.outrosExamesLaboratoriais,
              e.target.value,
            ],
          }));
        }}
        isEditField={!readOnly}
        renderTags={() => null}
        placeholder="Digite"
      />

      <Stack direction="row" flexWrap="wrap" sx={{ mt: 1 }}>
        {data.outrosExamesLaboratoriais?.map((v) => (
          <Chip
            sx={{
              background: "#D3E3EB",
              color: "#1E729F",
              margin: "4px",
            }}
            disabled={readOnly}
            key={v}
            label={v}
            onDelete={(valor) => {
              setData((prevState) => ({
                ...prevState,
                outrosExamesLaboratoriais:
                  data.outrosExamesLaboratoriais.filter((data) => data !== v),
              }));
            }}
          />
        ))}
      </Stack>

      <Stack sx={{ mt: 2 }}>
        <FieldTextarea
          label="Observações"
          name="examesLaboratoriaisObservacao"
          value={data.examesLaboratoriaisObservacao ?? ""}
          setValue={(value) =>
            setData((prevState) => ({
              ...prevState,
              examesLaboratoriaisObservacao: value,
            }))
          }
          isEditField={!readOnly}
        />
      </Stack>
      {!readOnly && (
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 3,
          }}
        >
          <Button className="buttonText cancel" variant="outlined">
            Cancelar
          </Button>
          <Button
            className="buttonText submit"
            variant="contained"
            type="submit"
            name="laboratorial"
          >
            Salvar
          </Button>
        </Stack>
      )}
    </form>
  );
}
